cv.CustomFieldGroupsRowView = Marionette.LayoutView.extend({
  tagName : 'div',
  className: 'custom-field-group',
  template : cv.Templates['global/custom_fields_form/custom_field_groups_row'],

  behaviors: [{
    behaviorClass: cv.FormBehavior,
    suppress_notifications: true
  }],

  regions : {
    'custom_field_group_fields' : '.custom-field-group-fields'
  },

  events : {
    'dropGroup' : 'drop',
    'click .add-field a' : 'addField',
    'click .edit-group a' : 'editGroup',
    'click .delete-group a' : 'deleteGroup'
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    // To hold the collections
    this.fields = new cv.CustomFields();
    this.groups = new cv.CustomFieldGroups();

    // If we have any changes on our collections then propagate them
    // Don't do this for groups
    this.listenTo(this.fields, 'reset', function(){
      this.model.set('fields', this.fields.toJSON());

      if(this.fields.length == 3){
        this.$('.add-field').hide();
      }
    }, this);
    this.listenTo(this.groups, 'reset', function(){
      this.model.set('fields', this.groups.toJSON());
    }, this);
    this.listenTo(this.fields, 'add', function(){
      if(this.fields.length == 2){
        this.model.set('group_style', 'two_column');
      }
      if(this.fields.length == 3){
        this.model.set('group_style', 'three_column');
        this.$('.add-field').hide();
      }
      this.model.set('fields', this.fields.toJSON());
    }, this);
    this.listenTo(this.fields, 'remove', function(){
      if(this.fields.length == 0){
        this.model.collection.remove(this.model);
      }
      if(this.fields.length == 1){
        this.model.set('group_style', 'one_column');
      }
      if(this.fields.length == 2){
        this.model.set('group_style', 'two_column');
        this.$('.add-field').show();
      }
      this.model.set('fields', this.fields.toJSON());
    }, this);

    // If we are unlinking a nested group
    this.listenTo(vent, 'custom_field:unlink_groups', function(view){
      this.trigger('form:unlink', view);
    }, this);

    // If we are unlinking fields
    this.listenTo(vent, 'custom_field:unlink_fields', function(view){
      this.trigger('form:unlink', view);
    }, this);

    // View modes
    this.listenTo(vent, 'custom_field:edit_form', function(){
      this.$el.removeClass('form-group');
      this.$('.custom-field-group-heading').show();
    }, this);
    this.listenTo(vent, 'custom_field:preview_form', function(){
      this.$el.addClass('form-group');
      this.$('.custom-field-group-heading').hide();
    }, this);

    console.log('CustomFieldGroupsRowView initialized');
  },

  templateHelpers : function(){
    return {
      type : this.model.get('type'),
      is_edit_mode : this.options.edit_mode,
      is_repeating : this.model.get('type') == 'repeating' ? true : false
    }
  },

  drop: function(event, index) {
    this.$el.trigger('update-group-sort', [this.model, index]);
  },

  addField: function(e){
    e.preventDefault();

    if(this.fields.length == 3){
      return;
    }

    var view = new cv.EditCustomFieldView({
      add_field_to_group : true,
      model : new cv.CustomField({
        ordinal : this.fields.length
      })
    });
    vent.trigger('modal:show', view);

    this.listenTo(view, 'form:saved', function(view){
      this.fields.add(view.model);
  
      vent.trigger('modal:hide');
    }, this);
  },

  editGroup: function(e){
    e.preventDefault();

    var view = new cv.EditCustomFieldGroupView({
      model : this.model
    });
    vent.trigger('modal:show', view);

    this.listenTo(view, 'form:saved', function(){
      this.render();

      vent.trigger('modal:hide');
    }, this);
  },

  deleteGroup: function(e){
    e.preventDefault();

    // Load the modal
    var view = new cv.ConfirmView({
      message : 'Are you sure you want to delete this row.  You may lose data associated with these fields.'
    });
    vent.trigger('modal:show', view);

    view.on('confirm', function(){
      this.model.collection.remove(this.model);
    }, this);
  },

  onAttach: function(){
    if(this.options.edit_mode == false){
      this.$el.addClass('form-group');
    }
  },

  onRender: function(){
    if(this.model.get('type') == 'repeating' && this.options.edit_mode == false){
      // If we have no saved values for this repeating field,
      // just display the first one
      if(_.size(this.options.values[this.model.get('id')]) == 0){
        // Build an initial array with the new fields
        var test = [{
          label : this.model.get('label') + ' ' + 0,
          type : 'normal',
          group_style : this.model.get('group_style'),
          fields : this.model.get('fields')
        }];
      }else{
        var test = [];
        _.each(this.options.values[this.model.get('id')], function(item, index, list){
          // Build an initial array with the new fields
          test.push({
            label : this.model.get('label') + ' ' + index,
            type : 'normal',
            group_style : this.model.get('group_style'),
            fields : this.model.get('fields')
          });
        }, this);
      }

      // Save empty row fields
      var empty_row = [{
        label : this.model.get('label') + ' ' + 0,
        type : 'normal',
        group_style : this.model.get('group_style'),
        fields : this.model.get('fields')
      }];

      // Reset groups
      this.groups.reset(test);
      var view = new cv.CustomFieldGroupsView({
        model : this.model,
        collection : this.groups,
        group_index : this.model.collection.indexOf(this.model),
        edit_mode : this.options.edit_mode,
        values : this.options.values[this.model.get('id')],
        empty_row : empty_row,
        nested : true,
        is_donation_form : this.options.is_donation_form
      });
      this.trigger('form:link', view);
      this.showChildView('custom_field_group_fields', view);

      // When the form is saved set the fields collection
      this.listenTo(view, 'form:saved', function(view){
        this.groups.reset(view.collection.toJSON());
      }, this);
    }else{
      this.fields.reset(this.model.get('fields'));
      var view = new cv.CustomFieldsView({
        model : this.model,
        collection : this.fields,
        group_index : this.model.collection.indexOf(this.model),
        edit_mode : this.options.edit_mode,
        values : this.options.values,
        nested : this.options.nested,
        is_donation_form : this.options.is_donation_form
      });

      this.trigger('form:link', view);
      this.showChildView('custom_field_group_fields', view);

      // When the form is saved set the fields collection
      this.listenTo(view, 'form:saved', function(view){
        this.fields.reset(view.collection.toJSON());
      }, this);
    }
  },

  onDestroy: function(){
    // Unlink this row
    vent.trigger('custom_field:unlink_group', this);
  }
});
